export const Constants = {
    Api: {
        IsAuthorized: '/api/auth/isAuthorized',
        Language: '/api/auth/language',
        VeNewsFeed: '/api/home/news',
        Config: '/api/auth/config',
        TokenConfig: '/api/auth/tokenConfig',
        RefreshConfig: '/api/auth/refreshConfig'
    },
    RedirectUrl: {
        Home:'home',
        Error: 'error',
        Auth: 'auth',
        LocalNews: 'local',
        BigHome: 'big-home',
        BigLocalNews: 'big-local'
    },
    LocalStorage: {
        ComEntToken: 'ComEntToken',
        TokenConfig: 'TokenConfig',
        EncryptedToken: 'EncryptedToken'
    },
    BaseUrl: {
        Youtube_URL: 'https://www.youtube.com/embed',
        Blob_DEV_URL: 'https://CMETP-DEV-a8gjhbaygvawdpgn.a01.azurefd.net',
        Blob_UAT_URL: 'https://CMETP-RCT-dkembsccf8eydhdj.a01.azurefd.net',
        Blob_PRE_URL: 'https://CMETP-PRE-a7c7gkcvb8dhdkdk.a01.azurefd.net',
        Blob_PRD_URL:  'https://CMETP-drhdbaaahqbpg9a6.a01.azurefd.net',
    },
    Blob: {
        Container: 'communication-entreprise/',
        Images: 'Images/',
        Videos: 'Videos/',
        Fonds: 'Fonds/',
        ImageApp: 'image-app/',
        logo: 'Logo_mvnfbu.svg',
    },
    Images: {
        DefaultNews: '../../../assets/logo/logo_default_news.svg',
    },
    Animations: {
        Extension:'.gif',
        birthday: 'ANNIV',
        thanks: 'MERCI',
        success: 'SUCCES',
        welcome: 'BIENVENUE',
        bestPractice: 'BEST_PRACTICE',
        handling: 'HANDLING',
        fall:'FALL',
        electrical: 'ELECTRICAL',
        road: 'ROAD'
    },
    DisplayMode: {
        Normal: 'Normal',
        BigPicture: 'BigPicture'
    },
}